import { useRef, useState } from 'react';
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Stack,
  Typography,
} from '@mui/material';

import ErrorMessage from '@/components/errorMessage';
import ConsumedEvent from './consumedEvent';

type Props = {
  consumedEvents: any[];
  maxHeight?: number;
  onAddEvent: (consumedEvent: any) => void;
  onDeleteEvent: (consumedEvent: any) => void;
};

const ConsumedEvents = ({ consumedEvents = [], onAddEvent, onDeleteEvent }: Props) => {
  const [newEvent, setNewEvent] = useState(false);
  const [newEventError, setNewEventError] = useState('');

  const addNewEvent = () => {
    setNewEventError('');
    setNewEvent(true);
  };

  const addEvent = (consumedEvent: any) => {
    const ce = (consumedEvents || []).find(
      (es: any) =>
        es.entityType === consumedEvent.entityType &&
        es.entityDefId === consumedEvent.entityDefId &&
        es.entityId === consumedEvent.entityId &&
        es.eventDefId === consumedEvent.eventDefId,
    );
    if (!ce) {
      onAddEvent(consumedEvent);
      setNewEvent(false);
      setNewEventError('');
    } else {
      setNewEventError('Already exists');
    }
  };

  const cancelAdd = () => {
    setNewEventError('');
    setNewEvent(false);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1.5 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
          Consumed Events
        </Typography>
        <Button
          variant="contained"
          size="small"
          color="secondary"
          onClick={() => addNewEvent()}
          disabled={newEvent}
          sx={{ textTransform: 'none', fontWeight: 700, borderRadius: '8px', boxShadow: 'none' }}
        >
          Add New Event
        </Button>
      </Stack>

      <Box sx={{ flex: 1, overflow: 'auto' }}>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ borderRight: '1px solid', borderColor: 'divider', width: '23%', fontWeight: 700 }}>
                  Entity Type
                </TableCell>
                <TableCell sx={{ borderRight: '1px solid', borderColor: 'divider', width: '23%', fontWeight: 700 }}>
                  Entity Def
                </TableCell>
                <TableCell sx={{ borderRight: '1px solid', borderColor: 'divider', width: '23%', fontWeight: 700 }}>
                  Entity
                </TableCell>
                <TableCell sx={{ borderRight: '1px solid', borderColor: 'divider', width: '23%', fontWeight: 700 }}>
                  Event
                </TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {newEvent && (
                <ConsumedEvent
                  onAdd={addEvent}
                  onDelete={onDeleteEvent}
                  onCancelAdd={cancelAdd}
                  errror={newEventError}
                />
              )}
              {newEventError && (
                <TableRow>
                  <TableCell colSpan={5}>
                    <ErrorMessage error={{ message: newEventError }} />
                  </TableCell>
                </TableRow>
              )}
              {(consumedEvents || []).map((consumedEvent: any, idx: any) => {
                return (
                  <ConsumedEvent
                    key={idx}
                    consumedEvent={consumedEvent}
                    onAdd={addEvent}
                    onDelete={onDeleteEvent}
                    onCancelAdd={cancelAdd}
                  />
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default ConsumedEvents;
